import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ISelectOption } from '../../../../../../../../design/inputs/select/ISelectOption';
import { IImageFilters } from '../../../imageFilters.model';
import { FiltersDropdownRow } from '../FiltersDropdownRow';

interface ICorrectedFilterInfoProps {
  imageFilters: IImageFilters;
}

export const CorrectedFilterInfo = observer((props: ICorrectedFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  const options: ISelectOption<boolean>[] = [
    { label: t('yes'), value: true },
    { label: t('no'), value: false },
  ];
  const selectedOptions = options.filter((d) => props.imageFilters.corrected.includes(d.value));

  return (
    <FiltersDropdownRow
      label={t('image_filters.corrected')}
      count={selectedOptions.length}
    >
      <>
        {selectedOptions.map((d) => (
          <div key={d.value.toString()}>{d.label}</div>
        ))}
      </>
    </FiltersDropdownRow>
  );
});
